module.exports = __webpack_public_path__ + "static/img/news-info.df237446.webp";